import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import { ddmmyy, dateToTime } from "../utils/DateUtils";
import EditIcon from "@mui/icons-material/Edit";

import { CustomStyles } from "../component/CustomStyle";
import { android2, macintosh2, windows2, linux2 } from "../iconsImports";
import AuthContext from "../store/AuthContext";
import AddIcon from "@mui/icons-material/Add";

import CachedIcon from "@mui/icons-material/Cached";
import FilterCard from "../modals/FilterCard";
import AddUserKey from "./AddUserKey";
import ApiEndpoints from "../network/ApiEndPoints";
import AddUserCharges from "./AddUserCharges";
import EditUserCharge from "./EditUserCharge";
let refresh;
const Charges = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [openAddKey, setOpenAddKey] = useState(false);
  const [openEditKey, setOpenEditKey] = useState(false);
  const [editData, setEditData] = useState(null);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  // const normalizedData = Array.isArray(apiData)
  //   ? apiData
  //   : apiData
  //   ? [apiData]
  //   : [];
  // setApiData(normalizedData);

  const columns = [
    {
      name: "Created At",
      selector: (row) => (
        <div className="mb-1">
          {ddmmyy(row.created_at)}
          <br />
          {dateToTime(row.created_at)}
        </div>
      ),
    },
    {
      name: "User Id",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.user_id}
        </div>
      ),
    },
    {
      name: "payout1",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.payout1}
        </div>
      ),
    },
    {
      name: "payout2",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.payout2}
        </div>
      ),
    },
    {
      name: "payout3",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.payout3}
        </div>
      ),
    },
    {
      name: "payout4",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.payout4}
        </div>
      ),
    },
    {
      name: "payout5",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.payout5}
        </div>
      ),
    },
    {
      name: "Upi1",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.upi1}
        </div>
      ),
    },
    {
      name: "Upi2",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.upi2}
        </div>
      ),
    },
    {
      name: "Upi3",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.upi3}
        </div>
      ),
    },
    {
      name: "Upi4",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.upi4}
        </div>
      ),
    },
    {
      name: "min amount",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.min_amt}
        </div>
      ),
    },
    {
      name: "max amount",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.max_amt}
        </div>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <Tooltip title="Edit User Charge">
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              setEditData(row);
              setOpenEditKey(true);
            }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }

  return (
    <Box>
      <Grid>
        <ApiPaginateSearch
          showSearch={false}
          isFilterAllowed={true}
          filterComponent={
            <>
              <FilterCard
                ifuseridFilter
                setQuery={setQuery}
                query={query}
                clearHookCb={(cb) => {
                  refresh = cb;
                }}
                refresh={refresh}
                actionButtons={
                  <>
                    <AddUserCharges
                      open={openAddKey}
                      handleClose={() => setOpenAddKey(false)}
                      onSuccess={() => {
                        setOpenAddKey(false);
                        refreshFunc(setQuery); // auto refresh table
                      }}
                    />
                    <Tooltip title="refresh">
                      <IconButton
                        aria-label="refresh"
                        // color="success"
                        sx={{
                          color: "#0F52BA",
                        }}
                        onClick={() => {
                          refreshFunc(setQuery);
                        }}
                      >
                        <CachedIcon className="refresh-purple" />
                      </IconButton>
                    </Tooltip>
                  </>
                }
              />
            </>
          }
          apiEnd={ApiEndpoints.GET_USER_CHARGES}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        />
        <EditUserCharge
          open={openEditKey}
          data={editData}
          handleClose={() => {
            setOpenEditKey(false);
            setEditData(null);
          }}
          onSuccess={() => {
            setOpenEditKey(false);
            setEditData(null);
            refreshFunc(setQuery);
          }}
        />
      </Grid>
    </Box>
  );
};

export default Charges;
